// extracted by mini-css-extract-plugin
export var Card = "AwardCard-module--Card--xaWgJ";
export var Badge = "AwardCard-module--Badge--yZp4u";
export var Content = "AwardCard-module--Content--Q+p5k";
export var Year = "AwardCard-module--Year--cxzB+";
export var Title = "AwardCard-module--Title--Rt8YW";
export var Body = "AwardCard-module--Body--hmb+K";